var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    [
      _vm.event
        ? _c(
            "template",
            { slot: "header" },
            [
              _c(
                "ContentHeader",
                {
                  attrs: {
                    title: _vm.event.eventName,
                    "sub-title": _vm.event.start.displayDate,
                    "back-link": _vm.backLinkUrl,
                    "back-link-title": _vm.backLinkTitle,
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "actions" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn--primary",
                          attrs: {
                            to: {
                              name: "create-conference-document",
                              props: { event_id: _vm.id },
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Upload Document\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$wait.is("documents")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : _vm.event
        ? _c("div", [
            _c("h2", [_vm._v("Member Opportunities")]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "grid grid--cards" },
              [
                _vm.event.documents && _vm.event.documents.length
                  ? _vm._l(_vm.event.documents, function (document) {
                      return _c(
                        "li",
                        { staticClass: "col-md-6 col-lg-6 col-12" },
                        [
                          _c("Card", {
                            attrs: {
                              url: {
                                name: "preview-conference-document",
                                params: { document_id: document.id },
                              },
                              img: document.member_logo,
                              "contain-img": true,
                              title: document.name,
                              subTitle: document.updatedAt
                                ? document.updatedAt
                                : null,
                            },
                          }),
                        ],
                        1
                      )
                    })
                  : [
                      _c("li", { staticClass: "grid__error col-12" }, [
                        _c("span", { staticClass: "h2" }, [
                          _vm._v("No documents found"),
                        ]),
                      ]),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn--primary",
                    attrs: {
                      to: {
                        name: "create-conference-document",
                        props: { event_id: _vm.id },
                      },
                    },
                  },
                  [_vm._v("\n                Upload Document\n            ")]
                ),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "error" }, [
            _c("span", { staticClass: "h2" }, [
              _vm._v("Unable to load documents."),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--link",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.getData.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Retry")]
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }